import { styled } from '@mui/material';

export const Title = styled('div')({
  fontSize: 14,
  fontWeight: 700,
  textTransform: 'uppercase',
  marginBottom: 16,
});
